/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * @export
 * @class LmsMessageTabComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-message-tab',
  templateUrl: './lms-message-tab.component.html',
  styleUrls: ['./lms-message-tab.component.scss']
})

export class LmsMessageTabComponent implements OnInit {

  @Input() message: string;

  @Output() clearMessage = new EventEmitter();

  /**
   * Creates an instance of LmsMessageTabComponent.
   *
   * @memberOf LmsMessageTabComponent
   */
  constructor() { }

  /**
   * Lifecycle hooks to Initialize the component
   * @memberOf LmsMessageTabComponent
   */
  ngOnInit() {
  }

  /**
   * Close the error message
   * @memberOf LmsMessageTabComponent
   */
  closeErrorMessage() {
    this.clearMessage.emit(true);
  }

}
